/* common variables used across 'Users' module */

export const DEFAULT_ORGANIZATION = "NielsenIQ Studio";

export const DUMMY_PASSWORD = "Abcd1234";
